import View from './View'

const Container = ({register}) => <View title="Cadastro Unidade" register={register}/>

export default Container
